import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface ApplicationUpdatedDialogData {
	modifiedTime: string;
	lastDetailsSave: string;
}

// 'reload' loads the latest application; "Close" and the cross return undefined and change nothing
export type ApplicationUpdatedDialogResult = 'reload' | undefined;

/**
 * Shown when the application was updated after it was loaded: on switching tabs, and before a Details save
 */
@Component({
	selector: 'app-application-updated-dialog',
	templateUrl: './application-updated-dialog.component.html',
	styleUrls: ['./application-updated-dialog.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		CommonModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatTooltipModule,
	],
})
export class ApplicationUpdatedDialogComponent {
	readonly data = inject<ApplicationUpdatedDialogData>(MAT_DIALOG_DATA);
}
